import React from 'react';
import DevelopmentInProgress from '../../../../components/common/DevelopmentInProgress';

export default function PackagesGeneral() {
	return <DevelopmentInProgress />;
}
